import React, { Component } from "react";
import { connect } from "react-redux";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { UiActions } from "state/actions/UiActions";
import queryString from "query-string";
import { TokenActions } from "state/actions/user/TokenActions";
import { GlamboxCookieStore } from "core/glambox/GlamboxCookieStore";

class RegisterInstagram extends Component {
  /**
   * @type {GlamboxCookieStore}
   */
  cookieHandle = null;

  constructor (props) {
    super(props);

    this.cookieHandle = new GlamboxCookieStore(
      "/",
      process.env.REACT_APP_GB_COOKIE_ROOT,
      false,
      new Date(Date.now() + (60 * 60 * 3 * 1000))
    );
  }

  componentDidMount () {
    const {
      location,
      history, 
      token
    } = this.props;

    let qs = queryString.parse(location.search);
    let personId = this.cookieHandle.get("gbPersonId");
    let cookieWasSet = this.cookieHandle.get("gbRegisterInstagram");

    let redirectUrl = process.env.REACT_APP_GB_APP_ROOT + "/register-instagram";

    if (qs.code) {
      redirectUrl = `${redirectUrl}`;//?personId=${qs.personId}`;

      ExecuteRequest(
        GlamboxEndpoints.Person.instagramRegister,
        {
          personId: personId,
          code: qs.code,
          redirectUrl: redirectUrl
        },
        "POST",
        {
          Authorization: token.Authorization
        },
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;
  
          if (statusCode === 200) {
            //history.push("/");
            //history.push("/dados-pessoais");

            if (token !== null) {
              // TODO:
              //this.props.loginWithToken(token.access_token);
              this.props.identifyTokenAndPersonId(
                token.Authorization,
                personId
              );

              this.cookieHandle.set("gbRegisterInstagram", 1);
            }
          }

          history.push("/dados-pessoais");
        }
      );
    } else if ( qs.code && personId && !cookieWasSet ) {
      redirectUrl = `${redirectUrl}?personId=${personId}`;

      ExecuteRequest(
        GlamboxEndpoints.Person.instagramRegister,
        {
          personId: personId,
          code: qs.code,
          redirectUrl: redirectUrl
        },
        "POST",
        {
          Authorization: token.Authorization
        },
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;
  
          if (statusCode === 200) {
            //history.push("/");
            //history.push("/dados-pessoais");

            if (token !== null) {
              // TODO:
              //this.props.loginWithToken(token.access_token);
              this.props.identifyTokenAndPersonId(
                token.Authorization,
                personId
              );

              this.cookieHandle.set("gbRegisterInstagram", 1);
            }
          }

          history.push("/dados-pessoais");
        }
      );
    } else {
      if (cookieWasSet) {
        this.cookieHandle.remove("gbRegisterInstagram");
      }

      history.push("/dados-pessoais");
    }
  }

  render () {
    return null;
  }
}

const mapStateToProps = (state) => ({
  token: state.token.data
});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loginWithToken: (access_token) => {
    dispatch(TokenActions.loginWithToken(access_token));
  },
  identifyTokenAndPersonId: (token, personId) => {
    dispatch(TokenActions.identifyTokenAndPersonId(token, personId));
  }
});

RegisterInstagram = connect(
  mapStateToProps, 
  mapDispatchToProps
)(RegisterInstagram);

export {
  RegisterInstagram
};
